import { Components } from '@mui/material/styles';

const muiStepperStyles: Components = {
  MuiStepConnector: {
    styleOverrides: {
      line: {
        background: 'var(--gray-11)',
        height: '6px',
        border: 'none',
        borderRadius: '42px',
        margin: '0 auto'
      },
      root: {
        '&.Mui-active .MuiStepConnector-line': {
          background: 'var(--primary)'
        },
        '&.Mui-completed .MuiStepConnector-line': {
          background: 'var(--primary)'
        }
      }
    }
  },
  MuiStepIcon: {
    styleOverrides: {
      root: {
        color: 'var(--gray-11)',
        '& .MuiStepIcon-text': {
          fill: 'var(--gray-2)'
        },
        '&.Mui-active': {
          color: 'var(--primary)',
          '& .MuiStepIcon-text': {
            fill: 'var(--white)'
          }
        },
        '&.Mui-completed': {
          color: 'var(--primary)',
          '& .MuiStepIcon-text': {
            fill: 'var(--white)'
          }
        }
      }
    }
  },
  MuiStepLabel: {
    styleOverrides: {
      label: {
        color: 'var(--gray-2)',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: 'normal',
        '&.MuiStepLabel-alternativeLabel': {
          marginTop: '10px'
        },
        '&.Mui-completed': {
          color: 'var(--primary)',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: 600,
          lineHeight: 'normal'
        },
        '&.Mui-active': {
          color: 'var(--primary)',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: 600,
          lineHeight: 'normal'
        }
      }
    }
  }
};

export default muiStepperStyles;
